// extracted by mini-css-extract-plugin
export default {"container":"TermsCard_container__erMvY"};